<ng-container *ngIf="!isPdpLinks">
  <div class="flex flex-col">

    <section class="w-full h-full gap-3 mt-5" *ngIf="dataSource?.OtherHotels?.length">
      <h5>واحد های اقامتی دیگر</h5>
      <div class="w-full h-full flex flex-wrap justify-start items-center gap-3 mt-3">
        <div *ngFor="let item of dataSource?.OtherHotels"
          class="flex justify-between items-center primary-border px-1 text-blue-500 rounded-md hover:bg-slate-50 shadow-sm">
          <a [href]="item.Url" class="w-full h-full block">
            {{item.Text}}
          </a>
          <span class="ico-ArrowLeft mr-2"></span>
        </div>
      </div>
    </section>

    <section class="mt-5" *ngIf="dataSource?.PopularHotels?.length">
      <h5>خیابان های اطراف</h5>
      <div class="w-full h-full flex flex-wrap justify-start items-center gap-3 mt-3">
        <div *ngFor="let item of dataSource?.PopularHotels"
          class="flex justify-between items-center primary-border px-1 text-blue-500 rounded-md hover:bg-slate-50 shadow-sm">
          <a [href]="item.Url" class="w-full h-full block">
            {{item.Text}}
          </a>
          <span class="ico-ArrowLeft mr-2"></span>
        </div>
      </div>
    </section>

    <section class="mt-5" *ngIf="dataSource?.PageGeneratorLinks?.length">
      <h5>هتل های</h5>
      <div class="w-full h-full flex flex-wrap justify-start items-center gap-3 mt-3">
        <div *ngFor="let item of dataSource?.PageGeneratorLinks"
          class="flex justify-between items-center primary-border px-1 text-blue-500 rounded-md hover:bg-slate-50 shadow-sm">
          <a [href]="item.Url" class="w-full h-full block">
            {{item.Text}}
          </a>
          <span class="ico-ArrowLeft mr-2"></span>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<section class="mt-5" *ngIf="pdpLinks?.length">
  <h5>خیابان های اطراف</h5>
  <div class="w-full h-full flex flex-wrap justify-start items-center gap-3 mt-3">
    <div *ngFor="let item of pdpLinks"
      class="flex justify-between items-center primary-border px-1 text-blue-500 rounded-md hover:bg-slate-50 shadow-sm">
      <a [href]="item.Url" class="w-full h-full block">
        {{item.Text}}
      </a>
      <span class="ico-ArrowLeft mr-2"></span>
    </div>
  </div>
</section>

<section class="mt-5" *ngIf="pdpPageGeneratorLinks?.length">
  <h5>لینک‌های مرتبط</h5>
  <div class="w-full h-full flex flex-wrap justify-start items-center gap-3 mt-3">
    <div *ngFor="let item of pdpPageGeneratorLinks"
      class="flex justify-between items-center primary-border px-1 text-blue-500 rounded-md hover:bg-slate-50 shadow-sm">
      <a [href]="item.Url" class="w-full h-full block">
        {{item.Text}}
      </a>
      <span class="ico-ArrowLeft mr-2"></span>
    </div>
  </div>
</section>